import React from "react";
import { Link } from "react-router-dom";
import { Sprout, UtensilsCrossed, Sparkles } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const Home = () => {
  const { isAuthenticated, isBreeder } = useAuth();

  return (
    <div>
      <div className="hero">
        <div className="container">
          <h1>🐔 PouletDirect</h1>
          <p>
            La marketplace qui connecte directement les éleveurs 
            et les restaurateurs. Transparence, traçabilité et qualité garanties.
          </p>
          {!isAuthenticated && (
            <div className="hero-actions">
              <Link to="/register" className="btn btn-primary btn-lg">
                Commencer
              </Link>
              <Link to="/products" className="btn btn-outline btn-lg">
                Voir les produits
              </Link>
            </div>
          )}
        </div>
      </div>

      <div className="container main-content">
        <div className="home-sections">
        <div className="grid grid-3" style={{ marginBottom: "3rem" }}>
          <div className="card">
            <div className="card-header">
              <h3 className="card-title icon-title"><Sprout size={22} strokeWidth={2.25} /> Pour les Éleveurs</h3>
            </div>
            <div className="card-body">
              <p>
                Mettez en avant vos produits, gérez vos stocks et développez 
                votre activité en contact direct avec les restaurateurs.
              </p>
              <ul style={{ marginTop: "1rem", paddingLeft: "1.5rem" }}>
                <li>Gestion de vos produits</li>
                <li>Suivi des commandes</li>
                <li>Certifications visibles</li>
                <li>Contact direct</li>
              </ul>
            </div>
            {!isAuthenticated && (
              <div className="card-footer">
                <Link to="/register" className="btn btn-primary">
                  Devenir éleveur
                </Link>
              </div>
            )}
          </div>

          <div className="card">
            <div className="card-header">
              <h3 className="card-title icon-title"><UtensilsCrossed size={22} strokeWidth={2.25} /> Pour les Restaurateurs</h3>
            </div>
            <div className="card-body">
              <p>
                Trouvez des éleveurs locaux, commandez des produits de qualité 
                et développez votre offre avec des ingrédients tracés.
              </p>
              <ul style={{ marginTop: "1rem", paddingLeft: "1.5rem" }}>
                <li>Recherche d'éleveurs</li>
                <li>Commandes simplifiées</li>
                <li>Traçabilité garantie</li>
                <li>Qualité premium</li>
              </ul>
            </div>
            {!isAuthenticated && (
              <div className="card-footer">
                <Link to="/register" className="btn btn-primary">
                  Devenir restaurateur
                </Link>
              </div>
            )}
          </div>

          <div className="card">
            <div className="card-header">
              <h3 className="card-title icon-title"><Sparkles size={22} strokeWidth={2.25} /> Avantages</h3>
            </div>
            <div className="card-body">
              <p>
                Une plateforme simple, sécurisée et transparente pour 
                faciliter les échanges entre professionnels.
              </p>
              <ul style={{ marginTop: "1rem", paddingLeft: "1.5rem" }}>
                <li>Paiement sécurisé</li>
                <li>Messagerie intégrée</li>
                <li>Système d'avis</li>
                <li>Support client</li>
              </ul>
            </div>
            <div className="card-footer">
              <Link to="/products" className="btn btn-outline">
                Découvrir
              </Link>
            </div>
          </div>
        </div>

        {isAuthenticated && (
          <div className="welcome-section" data-tour="home-welcome">
            <h2>Bienvenue {isBreeder ? "éleveur" : "restaurateur"} !</h2>
            <div className="welcome-actions">
              {isBreeder ? (
                <Link to="/products/create" className="btn btn-primary btn-lg" data-tour="home-add-product">
                  Ajouter un produit
                </Link>
              ) : (
                <Link to="/products" className="btn btn-primary btn-lg" data-tour="home-browse-products">
                  Voir les produits
                </Link>
              )}
              <Link to="/orders" className="btn btn-outline btn-lg">
                Mes commandes
              </Link>
            </div>
          </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default Home;

